import { atom } from 'recoil';

const refetchNotifications = atom({
  key: 'refetchNotifications',
  default: 0
});


export { refetchNotifications };
